import React from 'react';
import './SelectBox.css';
import {
    getBorderLessOptionLabel,
    getBorderLessSelectClassName,
    getConstantSelectClassName,
    getDefaultOptionLabel,
    getOptionKey,
} from './SelectBox.helpers';

const BorderLessSelect = (props) => (
    <select
        className={getBorderLessSelectClassName(props)}
        aria-label='Default select example'
        id={props.id}
        placeholder={props.placeholder}
        onChange={props.onChange}
        value={props.value}
        name={props.name}
        disabled={props.disabled}>
        {props.data && props.data.length >= 1
            ? props.data.map((e) => (
                  <option key={getOptionKey(e)} ulid={e.ulid} value={e.value}>
                      {getBorderLessOptionLabel(props.label, e)}
                  </option>
              ))
            : props.data && (
                  <option ulid={props.data.ulid} value={props.data.value}>
                      {props.data.name}
                  </option>
              )}
    </select>
);

const ConstantDropdownsSelect = (props) => (
    <select
        className={getConstantSelectClassName(props)}
        aria-label='Default select example'
        id={props.id}
        placeholder={props.placeholder}
        onChange={props.onChange}
        value={props.value}
        name={props.name}
        disabled={props.disabled}>
        <option value=''>{props.placeholder || 'Select'}</option>
        {props.data && props.data.length >= 1
            ? props.data.map((e) => (
                  <option key={getOptionKey(e)} ulid={e.ulid} value={e.value} disabled={e.disabled}>
                      {e.name}
                  </option>
              ))
            : props.data && (
                  <option ulid={props.data?.ulid} value={props.data?.value}>
                      {props.data?.name}
                  </option>
              )}
    </select>
);

const DefaultSelect = (props) => (
    <select
        className={getConstantSelectClassName(props)}
        aria-label='Default select example'
        id={props.id}
        placeholder={props.placeholder}
        onChange={props.onChange}
        value={props.value}
        name={props.name}
        disabled={props.disabled}>
        <option value=''>Select</option>
        {props.data && props.data.length >= 1
            ? props.data.map((e) => (
                  <option key={getOptionKey(e)} ulid={e.ulid} value={e.name} disabled={e.disabled}>
                      {getDefaultOptionLabel(props.label, e)}
                  </option>
              ))
            : props.data && (
                  <option ulid={props.data.ulid} value={props.data.name}>
                      {props.data.name}
                  </option>
              )}
    </select>
);

const SelectBox = (props) => {
    let selectElement;
    if (props.type === 'borderLessRoleType') {
        selectElement = <BorderLessSelect {...props} />;
    } else if (props.type === 'constantDropdowns') {
        selectElement = <ConstantDropdownsSelect {...props} />;
    } else {
        selectElement = <DefaultSelect {...props} />;
    }

    return (
        <div className=''>
            {props.label && props.type !== 'borderLessRoleType' && props.label !== 'null' && (
                <label htmlFor='userEmail' className='form-label text-neutral-850 font-b3 mb-1'>
                    {props.label ? props.label : ''} {props.isRequiredNeeded ? <span className='ms-n1'>*</span> : ''}
                </label>
            )}

            {selectElement}

            {props.error && <p className='text-error-700 font-b3 font-regular mt-2'>{props.errorMessage}</p>}
        </div>
    );
};

export default SelectBox;
